import {
  BarChartHorizontal,
  ComparisonBarChart,
  DistributionChart,
  PieChart,
  TrendChart,
} from '@/components/molecules';
import { HeatMapChart } from '@/components/molecules/HeatMapChart/HeatMapChart';
import {
  BAR_CHART_MOCK_DATA,
  DECLINED_CHART_MOCK_DATA,
  DISTRIBUTION_CHART_MOCK_DATA,
  HEATMAP_CHART_MOCK_DATA,
  IMPROVEMENT_CHART_MOCK_DATA,
  PIE_CHART_MOCK_DATA,
  TREND_CHART_MOCK_DATA,
  TREND_CHART_MOCK_LINES,
} from '@/components/organisms/EditCell/components/EditCellChartRenderer/constants';
import {
  DimensionValue,
  VisualisationValue,
} from '@/components/organisms/EditCell/components/EditCellSidebar/constants';
import { cn } from '@/utils/tailwind';

import { EditMetricsCell } from './components/EditMetricsCell';
import { EditTextCell } from './components/EditTextCell';

const EXCLUDED_SHADOW: VisualisationValue[] = ['text', 'metrics-card'];

type EditCellChartRendererProps = {
  selectedDimension: DimensionValue;
};

export const EditCellChartRenderer = ({ selectedDimension }: EditCellChartRendererProps) => {
  const showShadow = !EXCLUDED_SHADOW.includes(selectedDimension.value);

  const renderChart = () => {
    switch (selectedDimension.value) {
      case 'trend-line-chart':
        return (
          <TrendChart
            data={TREND_CHART_MOCK_DATA}
            lines={TREND_CHART_MOCK_LINES}
            title="Avg. Employee count"
            isEditCellSkeleton
          />
        );
      case 'bar-chart':
        return (
          <BarChartHorizontal
            title="Work-Life Balance score"
            xKey="name"
            yKey="value"
            data={BAR_CHART_MOCK_DATA}
            isEditCellSkeleton
          />
        );
      case 'metrics-card':
        return <EditMetricsCell title="Avg. Employee count" />;
      case 'pie-chart':
        return (
          <PieChart
            data={PIE_CHART_MOCK_DATA}
            title="Avg. Employee count"
            changeValue={0}
            total={0}
            isEditCellSkeleton
          />
        );
      case 'heatmap-chart':
        return (
          <HeatMapChart
            data={HEATMAP_CHART_MOCK_DATA}
            title="Intensity across departments"
            className="min-w-[676px]"
            isEditCellSkeleton
          />
        );
      case 'distribution-chart':
        return (
          <DistributionChart
            title="Distribution of responses"
            xKey="name"
            yKey="value"
            data={DISTRIBUTION_CHART_MOCK_DATA}
            trendLineData={[36, 46, 72, 99, 80, 83]}
            isEditCellSkeleton
          />
        );
      case 'improvement-chart':
        return (
          <ComparisonBarChart
            title="Top 5 Improving questions in Work-Life Balance"
            xKey="name"
            yKey="value"
            data={IMPROVEMENT_CHART_MOCK_DATA}
            isEditCellSkeleton
          />
        );
      case 'decline-chart':
        return (
          <ComparisonBarChart
            title="Top 5 Improving questions in Work-Life Balance"
            xKey="name"
            yKey="value"
            data={DECLINED_CHART_MOCK_DATA}
            isEditCellSkeleton
            variant="declined"
          />
        );
      case 'text':
        return (
          <EditTextCell
            title="Leader’s metrics"
            description="Leader performance metrics and feedback overview"
          />
        );
      default:
        return <div />;
    }
  };

  return (
    <div
      className={cn('w-full flex items-center justify-center rounded-[12px]', {
        'shadow-edit-cell-chart': showShadow,
      })}
    >
      {renderChart()}
    </div>
  );
};
